import React from "react";

// MCStudio wordmark — "C" in coral, rest in ink (or reverse on dark bg)
export const Logo = ({ reverse = false, className = "", size = "text-2xl" }) => {
  const base = reverse ? "text-beige" : "text-ink";
  return (
    <span
      className={`font-display font-extrabold tracking-tighter ${size} ${base} ${className}`}
      data-testid="mc-logo"
    >
      M<span className="text-coral">C</span>Studio
    </span>
  );
};

export default Logo;
